/**
 * La escalera de la pre-oferta, en un solo lugar.
 *
 * Espeja `minimo_valido()` / `es_escalon_valido()` de `oferta_routes.py`. El
 * backend es el que decide, pero si el formulario deja mandar un monto que el
 * backend va a rechazar, la persona se entera después de apretar Ofertar.
 *
 * El salto NO es un piso, es el PELDAÑO: con base 1.000.000 y salto 500.000 las
 * ofertas válidas son 1.000.000, 1.500.000, 2.000.000… y 1.234.567 no es una
 * oferta válida aunque supere el mínimo. La escalera se ancla al PRECIO BASE
 * del animal, no al cero.
 *
 * Está acá y no copiado en cada pantalla porque ya pasó con el formatter del
 * monto: se arregló en la ficha y quedó vivo en el panel del comprador.
 */

// Dos tolerancias, en unidades distintas, y confundirlas cuesta plata:
// TOL_PESOS compara un resto expresado en pesos; TOL_REL corrige un cociente
// adimensional. Usar la misma en los dos lados hacía que dentro de la división
// valiera 0.005 × salto — 2.500 pesos con un salto de 500.000.
const TOL_PESOS = 0.005;
const TOL_REL   = 1e-9;

/** Primer peldaño estrictamente por encima de `valor`. */
export const escalonSiguiente = (valor, precioBase, salto) => {
  const base = Number(precioBase || 0);
  const paso = Number(salto || 0);
  if (paso <= 0) return Number(valor);
  const pasos = Math.floor((Number(valor) - base) / paso + TOL_REL) + 1;
  return base + pasos * paso;
};

/** ¿El monto cae exactamente sobre un peldaño? */
export const enEscalon = (valor, precioBase, salto) => {
  const paso = Number(salto || 0);
  if (paso <= 0) return true;
  const resto = Math.abs((Number(valor) - Number(precioBase || 0)) % paso);
  return resto < TOL_PESOS || Math.abs(resto - paso) < TOL_PESOS;
};

/**
 * Menor monto ofertable.
 *
 * Sin ofertas previas es el precio base (se puede igualar). Con ofertas, el
 * peldaño siguiente. Una "mejor oferta" POR DEBAJO del precio base se ignora:
 * no existe en el dominio, y la escalera anclada a la base no está definida ahí
 * —`escalonSiguiente(0)` devolvía el salto, y el input quedaba precargado con
 * $250.000 en un animal de $10.000.000—.
 */
export const minimoOfertable = ({ precioBase, salto, mejorOferta }) => {
  const base  = Number(precioBase || 0);
  const paso  = Number(salto || 0);
  const mejor = Number(mejorOferta || 0);
  if (!Number.isFinite(mejor) || mejor < base) return base;
  return paso > 0 ? escalonSiguiente(mejor, base, paso) : mejor + 0.01;
};
